// extracted by mini-css-extract-plugin
export default {"tx":"e16778e5d2","line":"a5a3c13143"};